import { render, staticRenderFns } from "./AutoCloseBlock.vue?vue&type=template&id=174f55c0&scoped=true"
import script from "./AutoCloseBlock.vue?vue&type=script&lang=js"
export * from "./AutoCloseBlock.vue?vue&type=script&lang=js"
import style0 from "./AutoCloseBlock.vue?vue&type=style&index=0&id=174f55c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174f55c0",
  null
  
)

export default component.exports